import { ParsedUrlQueryInput } from 'querystring';

import { createRef } from 'react';

import {
  KidInterface,
  ListingSearchRoomInterface,
} from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import { FILTERS_QUERY_PARAMS, HOTEL_SEARCH_TYPES } from '@constants/constants';
import { HotelPromotionType, WebUrlType } from '@api/v3';
import { generateUUID } from '@utils/generateUUID';

type FormatedRoomsProps = {
  title: string;
  adultCount: number;
  childrenList: FormatedChildProps[];
  error: boolean;
  key: string;
};
type FormatedChildProps = {
  age: Date | string;
  error?: boolean;
};
// =========================================================================
// This function is for converting the query params to hotel rooms
// =========================================================================
export const convertQueryRoomToHotelRooms = (room: string) => {
  const rooms: Array<ListingSearchRoomInterface> = [];

  if (room) {
    if (Array.isArray(room)) {
      room.forEach((item) => {
        const [adultCount, ...others] = item.split('_');
        const children: Array<KidInterface> = [];

        others?.map((item: string) =>
          children.push({
            id: generateUUID(),
            error: false,
            age: item?.replace(/-/g, '/')?.split('/')?.reverse()?.join('/'),
          })
        );
        rooms.push({
          id: generateUUID(),
          adultCount: Number(adultCount),
          childrenList: children,
          title: `${rooms.length + 1}. Oda`,
          closable: true,
          error: false,
          key: rooms.length > 0 ? String(rooms[rooms.length - 1].key + 1) : '1',
          ref: createRef<HTMLDivElement>(),
        });
      });
    } else {
      const [adultCount, ...others] = room.split('_');
      const children: Array<KidInterface> = [];
      others?.map((item) =>
        children.push({
          id: generateUUID(),
          error: false,
          age: item?.replace(/-/g, '/')?.split('/')?.reverse()?.join('/'),
        })
      );
      rooms.push({
        id: generateUUID(),
        adultCount: Number(adultCount),
        childrenList: children,
        title: `${rooms.length + 1}. Oda`,
        closable: true,
        error: false,
        key: rooms.length > 0 ? String(rooms[rooms.length - 1].key + 1) : '1',
        ref: createRef<HTMLDivElement>(),
      });
    }
  }

  return rooms;
};

// =========================================================================
// This function is for clear the filter params from the query object
// =========================================================================
export const clearQueryParamsFilters = (query: ParsedUrlQueryInput) => {
  const nextQuery = { ...query };
  for (let i = 0; i < FILTERS_QUERY_PARAMS.length; i++) {
    delete nextQuery[FILTERS_QUERY_PARAMS[i]];
  }

  return nextQuery;
};

// =========================================================================
// This function is for getting the hotel search type (Listing | Detail)
// =========================================================================
export const getHotelSearchURLType = (itemType: string) => {
  return itemType === WebUrlType.HOTEL_CITY ||
    itemType === WebUrlType.HOTEL_REGION ||
    itemType === WebUrlType.HOTEL_CHAIN
    ? HOTEL_SEARCH_TYPES.HOTEL_LISTING
    : HOTEL_SEARCH_TYPES.HOTEL_DETAIL;
};

// =========================================================================
// This function is for getting the discount type ( % | number)
// =========================================================================
export const getDiscountType = (type?: HotelPromotionType) => {
  return type === HotelPromotionType.PERCENT_DISCOUNT
    ? 'percent'
    : type === HotelPromotionType.VALUE_DISCOUNT
    ? 'value'
    : 'percent';
};
export const formatRooms = (hotelRooms: ListingSearchRoomInterface[]) => {
  const rooms: FormatedRoomsProps[] = [];

  hotelRooms?.forEach((room) => {
    rooms.push({
      title: room.title,

      adultCount: room.adultCount,

      childrenList: formatRoomChildren(room.childrenList),

      error: room.error,

      key: room.key,
    });
  });

  return rooms;
};

export const formatRoomChildren = (roomChildren: KidInterface[]) => {
  const children: FormatedChildProps[] = [];

  roomChildren?.forEach((child) => {
    children.push({
      age: child.age,

      error: child.error,
    });
  });

  return children;
};
